/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UnlinkTeamsInput = {
    projectId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type UnlinkTeamsMutationVariables = {
    input: UnlinkTeamsInput;
};
export type UnlinkTeamsMutationResponse = {
    readonly unlinkTeams: {
        readonly project: {
            readonly teamsId: string | null;
        } | null;
    } | null;
};
export type UnlinkTeamsMutation = {
    readonly response: UnlinkTeamsMutationResponse;
    readonly variables: UnlinkTeamsMutationVariables;
};



/*
mutation UnlinkTeamsMutation(
  $input: UnlinkTeamsInput!
) {
  unlinkTeams(input: $input) {
    project {
      teamsId
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UnlinkTeamsInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamsId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnlinkTeamsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkTeamsPayload",
        "kind": "LinkedField",
        "name": "unlinkTeams",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnlinkTeamsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkTeamsPayload",
        "kind": "LinkedField",
        "name": "unlinkTeams",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UnlinkTeamsMutation",
    "operationKind": "mutation",
    "text": "mutation UnlinkTeamsMutation(\n  $input: UnlinkTeamsInput!\n) {\n  unlinkTeams(input: $input) {\n    project {\n      teamsId\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '1ce145155e6138f3c6139504d5d07613';
export default node;
